





























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ChatService from '@/services/ChatService'
import { groupchatRef } from '@/firebase'
import { EListSort } from '@/models/Setting/Enum'
import LoadingChatList from '@/components/Loading/LoadingChatList.vue'
import store from '@/store'
import Setting from '@/store/modules/Setting'
import { getModule } from 'vuex-module-decorators'
import ChatListDisplay from './ChatListDisplay.vue'
const SettingModule = getModule(Setting, store)

interface IDropDown {
  id: number
  value: any
  text: string
  suffix?: string
}

@Component({ components: { LoadingChatList, ChatListDisplay } })
export default class ChatList extends Vue {
  // unpin chat params
  groupChats: any[] = []
  private page: number = 1
  isLoading: boolean = true
  isShowLoadMore: boolean = false

  sortOptions: IDropDown[] = []
  sortSelected: any = {}

  private unsubscribe: any

  isCheckAll: boolean = false
  isSelectAnyItem: boolean = false

  private ATTACH_FILE: string = 'ATTACH_FILE'
  private MESSAGE_DELETED: string = 'MESSAGE_DELETED'
  private LEAVE_GROUP_CHAT: string = 'LEAVE_GROUP_CHAT'
  private LEAVE_SYSTEM: string = 'LEAVE_SYSTEM'

  created() {
    this.initSortDropdown()
    this.handleRealTimeGorupChat()
  }

  destroyed() {
    this.unsubscribe()
  }

  @Watch('sortSelected')
  watchSortChange() {
    SettingModule.CHANGE_SORT_CHAT_LIST(this.sortSelected.id)
    setTimeout(async () => {
      await this.getGroupChat()
    }, 10)
  }

  initSortDropdown() {
    const data = [
      {
        id: EListSort.UPDATE_DESC,
        value: {
          order_by: 'updated_at',
          sorted_by: 'desc'
        },
        text:
          this.$t('common.dropdown_sort.sort_date_time') +
          '' +
          this.$t('common.dropdown_sort.desc')
      },
      {
        id: EListSort.UPDATE_ASC,
        value: {
          order_by: 'updated_at',
          sorted_by: 'asc'
        },
        text:
          this.$t('common.dropdown_sort.sort_date_time') +
          '' +
          this.$t('common.dropdown_sort.asc')
      },
      {
        id: EListSort.TITLE_DESC,
        value: {
          order_by: 'name',
          sorted_by: 'desc'
        },
        text:
          this.$t('common.dropdown_sort.sort_title_name') +
          '' +
          this.$t('common.dropdown_sort.desc')
      },
      {
        id: EListSort.TITLE_ASC,
        value: {
          order_by: 'name',
          sorted_by: 'asc'
        },
        text:
          this.$t('common.dropdown_sort.sort_title_name') +
          '' +
          this.$t('common.dropdown_sort.asc')
      }
    ]
    this.sortOptions = data
    this.sortSelected = data[this.$store.state.setting.user_sort.chat_list]
  }

  async filterGroupChat(index: number) {
    this.sortSelected = this.sortOptions[index]
    this.page = 1
    this.groupChats = []
    await this.getGroupChat()
  }

  @Watch('$store.state.userInfo.user.info.id')
  handleRealTimeGorupChat() {
    let trackingRealtime = true
    const userId = this.$store.state.userInfo.user.info.id
    if (!userId) return
    const start = this.moment()
      .subtract(1, 'm')
      .toDate()
    this.unsubscribe = groupchatRef
      .where('userIds', 'array-contains', userId)
      .where('updatedAt', '>', start)
      .onSnapshot(async (querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else {
          await this.getGroupChat()
        }
      })
  }

  async getGroupChatsApi({ dataSearch, callback }: any) {
    await ChatService.getGroupChats(dataSearch)
      .then((res: any) => {
        if (res.status === 200) {
          callback(res)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  async getGroupChat(loadMore?: boolean) {
    let dataSearch: any = {
      isGetUnRead: 0,
      orderBy: this.sortSelected.value.order_by,
      sortedBy: this.sortSelected.value.sorted_by,
      limit: this.$store.state.setting.setting.setting_display
        .number_item_lists,
      page: this.page
    }

    this.isLoading = true
    await this.getGroupChatsApi({
      dataSearch,
      callback: (res: any) => {
        this.isShowLoadMore = this.page < res.data.last_page ? true : false
        const mappingData = res.data.data.map((item: any) => ({
          ...item,
          isTranslated: this.isSystemMessage(item.last_message) ? true : false,
          translatedText: ''
        }))
        this.groupChats = loadMore
          ? [...this.groupChats, ...mappingData]
          : mappingData
      }
    })
    this.isLoading = false
  }

  loadMoreUnreadGroupChat() {
    this.page++
    if (this.groupChats.some(group => group.checked)) {
      this.isCheckAll = false
    }
    this.getGroupChat(true)
  }

  markReadGroupChat(index: number) {
    let groupChatMarkRead = this.groupChats[index]
    let data: any = {
      group_chat_id: groupChatMarkRead.id,
      count_message_not_seen: 0
    }

    ChatService.markReadGroupChat(data)
      .then(async res => {
        if (res.status === 200) {
          await ChatService.markReadChatMention({
            group_chat_id: groupChatMarkRead.id,
          })
          groupChatMarkRead.count_message_not_seen = 0
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  async pinGroupChatApi(payload: { id: number; is_pin: boolean }[]) {
    try {
      const res: any = await ChatService.pinGroupChat(payload)
      if (res.status === 200) {
        const idMap = new Map(payload.map(p => [p.id, p.is_pin]))
        this.groupChats = this.groupChats.map(item =>
          idMap.has(item.id)
            ? { ...item, is_pin: idMap.get(item.id)!, checked: false }
            : item
        )
        this.isCheckAll = false
        this.isSelectAnyItem = false
      }
    } catch (err) {
      console.log(err)
    }
  }

  async togglePinChatGroup(group: any) {
    let payload = [
      {
        id: Number(group.id),
        is_pin: !group.is_pin
      }
    ]
    await this.pinGroupChatApi(payload)
  }

  async pinMultipleChatGroups() {
    let payload = this.groupChats
      .filter((topic: { checked: any }) => topic.checked)
      .map((topic: { id: any; is_pin: boolean }) => ({
        id: Number(topic.id),
        is_pin: !topic.is_pin
      }))

    await this.pinGroupChatApi(payload)
  }

  /**
   * Handle is any checkbox is check
   */
  handleSelectAnyItem(isSelect: boolean) {
    this.isSelectAnyItem = isSelect
  }

  handleCheckAll(checkAll: boolean) {
    this.isCheckAll = checkAll

    if (checkAll) {
      const hasChecked = this.groupChats.some(item => item.checked)

      if (!hasChecked) {
        const hasUnpinned = this.groupChats.some(item => !item.is_pin)
        this.groupChats = this.groupChats.map(item => ({
          ...item,
          checked: hasUnpinned ? !item.is_pin : item.is_pin
        }))
      } else {
        const hasPinnedChecked = this.groupChats.some(
          item => item.is_pin && item.checked
        )
        const hasUnpinnedChecked = this.groupChats.some(
          item => !item.is_pin && item.checked
        )

        this.groupChats = this.groupChats.map(item => ({
          ...item,
          checked:
            (hasPinnedChecked && item.is_pin) ||
            (hasUnpinnedChecked && !item.is_pin)
        }))
      }

      this.handleSelectAnyItem(true)
    } else {
      this.groupChats = this.groupChats.map(item => ({
        ...item,
        checked: false
      }))
      this.handleSelectAnyItem(false)
    }
  }

  groupChatLastMess(keyCode: string) {
    if (!keyCode) return ''
    const text = keyCode.split(',')[0]
    switch (text) {
      case this.ATTACH_FILE:
        return this.$t('common.message.chat_no_content')
      case this.MESSAGE_DELETED:
        return this.$t('chat.list.msg.msg_deleted')
      case this.LEAVE_GROUP_CHAT:
        return this.$t('chat.list.msg.leave_group_chat', {
          name: keyCode.split(',')[1]
        })
      case this.LEAVE_SYSTEM:
        return this.$t('chat.list.msg.leave_system', {
          name: keyCode.split(',')[1]
        })
      default:
        return keyCode
    }
  }

  isSystemMessage(code: string): boolean {
    const text = code?.split(',')?.[0]
    return [
      this.ATTACH_FILE,
      this.MESSAGE_DELETED,
      this.LEAVE_GROUP_CHAT,
      this.LEAVE_SYSTEM
    ].includes(text)
  }
}
